import { useComponentsContext } from "@blocknote/react";

import UIcon from "lib/icons/untitled_ui/UIcon";
import { useStotlesBlockNoteEditor } from "../useStotlesBlockNoteEditor";

export default function RedoButton() {
  const editor = useStotlesBlockNoteEditor();
  const Components = useComponentsContext();

  const handleRedo = () => {
    editor.redo();
  };

  if (!Components) {
    return <></>;
  }

  return (
    <Components.FormattingToolbar.Button
      label=""
      icon={<UIcon icon="reverseRight" />}
      mainTooltip="Redo"
      onClick={handleRedo}
    />
  );
}
